import React, { useState } from "react";
import { GrFormPrevious } from "react-icons/gr";
import GroupChatSearch from "../../ChannelSidebar/GroupChatSearch/GroupChatSearch";
import SelectedChatAvatars from "../../ChannelSidebar/GroupChatList/GroupChatsSectionListItems/GroupChatSections/SelectedChatAvatars/SelectedChatAvatars";
import ChatListFooter from "../../ChannelSidebar/GroupChatList/GroupChatsSectionListItems/GroupChatSections/ChatListFooter/ChatListFooter";
import AllUserList from "../../../../Components/AllUserList/AllUserList";
import InfiniteScroll from "../../../../Components/InfiniteScroll/InfiniteScroll";

export default function AddGroupMember({
  allUser,
  activeChannel,
  setActiveSection,
  setShowAddGroupMember,
  createNewGroupSection = 0,
  createNewChannelSection = 0,
  setCreateNewGroupSection,
  setCreateNewChannelSection,
  addUser,
  showAddGroupMember,
  fetchAllUser,
  allUserCurrentPage,
  allUserTotalPages,
}) {
  const isGroupStepOne = createNewGroupSection === 1;
  const isGroupStepTwo = createNewGroupSection === 2;
  const isChannelStepFour = createNewChannelSection === 4;
  const isChannelInactive = ![1, 2, 3].includes(createNewChannelSection);

  const [selectedChats, setSelectedChats] = useState([]);

  const handleSelectChat = (user) => {
    const alreadySelected = selectedChats.find((u) => u._id === user._id);
    if (alreadySelected) {
      setSelectedChats((prev) => prev.filter((u) => u._id !== user._id));
    } else {
      setSelectedChats((prev) => [...prev, user]);
    }
  };

  const handleRemoveSelected = (id) => {
    setSelectedChats((prev) => prev.filter((chat) => chat._id !== id));
  };

  return (
    <section className="h-screen flex flex-col">
      {/* Header */}
      <div className="sticky top-0 z-20 border-b border-[#EBEBEB] bg-white p-4 flex items-center gap-4">
        <GrFormPrevious
          onClick={() => {
            setActiveSection("contact");
            setShowAddGroupMember(false);
          }}
          className="cursor-pointer hover:text-[var(--primary-color)] h-8 w-8 p-1 border rounded-md"
        />
        <h1 className="text-lg font-semibold">Add Followers</h1>
      </div>

      {/* Top Sticky: Chat Search */}
      {!isGroupStepTwo && isChannelInactive && (
        <div className="sticky  z-10 bg-white px-4 pt-4 ">
          <GroupChatSearch
            createNewChannelSection={4}
            fetchAllUser={fetchAllUser}
          />
        </div>
      )}

      {/* Scrollable Body */}
      <div className="flex-1 flex flex-col overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200 px-4">
        {/* Selected Avatars */}
        {selectedChats.length > 0 && (
          <SelectedChatAvatars
            selectedChats={selectedChats}
            handleRemoveSelected={handleRemoveSelected}
          />
        )}

        {/* Chat List */}
        {!isGroupStepTwo && isChannelInactive && (
          <>
            {allUser?.length > 0 && (
              <InfiniteScroll
                dataLength={allUser.length}
                next={() => fetchAllUser(allUserCurrentPage + 1, "")}
                hasMore={allUserCurrentPage < allUserTotalPages}
                loader={<p className="text-center">Loading...</p>}
              >
                {allUser.map((item) => (
                  <AllUserList
                    key={item._id}
                    users={item}
                    selected={selectedChats.some((u) => u._id === item._id)}
                    handleSelectChat={handleSelectChat}
                  />
                ))}
              </InfiniteScroll>
            )}
            {allUser.length <= 0 && (
              <div className="flex-grow flex items-center justify-center">
                <p className="text-[#7104F8] font-semibold">
                  Follower Not Found
                </p>
              </div>
            )}
          </>
        )}
      </div>

      {/* Bottom Sticky: Footer */}
      {selectedChats.length > 0 && (
        <div className="sticky bottom-0 bg-white z-20 p-4 ">
          <ChatListFooter
            onDone={async () => {
              await addUser(selectedChats);
              setSelectedChats([]);
              setActiveSection("contact");
              setShowAddGroupMember(false);
            }}
          />
        </div>
      )}
    </section>
  );
}
